import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { ActivityReport } from '@/models/activity-report.model';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { deleteActivityReport } from '@/services/activity-report.service';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import AssignClubEventDialog from './assign-club-event-dialog';
import { useNavigate } from 'react-router-dom';
import { Button, Message, PanelGroup, useToaster } from 'rsuite';



interface ActivityReportActionsProps{
    formObject?: ActivityReport;
};

const ActivityReportActions: React.FC<ActivityReportActionsProps> = ({formObject}) => {
  const [loadingDeleteActivityReport, setLoadingDeleteActivityReport] = useState(false);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const nav = useNavigate();
  const toaster = useToaster();

  const handleClickDeleteActivityReport = () => {
    if(!formObject) return;

    const handleYesClick = async () => {
      setLoadingDeleteActivityReport(true);
      try {
        const result: BaseResponseModel<null> = await deleteActivityReport(formObject.id);
        if (result.success) {
          toastSuccessMessage(`Report Successfully Removed.`);
          nav('/activities/reports');
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in deleting Report:${errorModel?.errorMessage}`);
      }
      finally {
        setLoadingDeleteActivityReport(false);
        toaster.clear(); 
      }
    };

    const handleNoClick = () => {
      toaster.clear(); 
    };

    toaster.push(
      <Message type="error" closable>
        <p style={{marginBottom:10}}>Are you sure you want to remove <strong>Report</strong>? It won&apos;t recoverable.</p>
        <div>
          <Button appearance="primary" color='red' onClick={handleYesClick}>Yes</Button>
          <Button appearance="subtle" onClick={handleNoClick} style={{ marginLeft:10}}>No</Button>
        </div>
      </Message>,
      { placement: 'topCenter', duration: 0 }
    );

  };


    return (
        <PageContent>
            <PanelGroup>
                <ActionPanel
                  title='Assign Path to Run Club Event'
                  description="Use this activity's route as the path of an existing run club event."
                  onClick={() => setAssignDialogOpen(true)}
                  loading={false}
                />
                <ActionPanel
                  title='Delete ActivityReport'
                  description='This action permanently remove the ActivityReport. It will not be recoverable.'
                  onClick={handleClickDeleteActivityReport}
                  loading={loadingDeleteActivityReport}
                  color='red'
                />
            </PanelGroup>
            {formObject && assignDialogOpen && (
              <AssignClubEventDialog open={assignDialogOpen} onClose={() => setAssignDialogOpen(false)} report={formObject} />
            )}
        </PageContent>
    );
};

export default ActivityReportActions;
